module.exports = __webpack_public_path__ + "static/img/CustomerService2x.1f985888.png";